import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const ScoreRatingCapacityPage = () => {
  return(
    <HomeUI />
  )
}

export default ScoreRatingCapacityPage;
